var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('HeaderPublic'),_c('v-content',[_c('router-view',{key:_vm.key,staticClass:"main-content"})],1),_c('FooterPublic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }